<script setup lang="ts">
import { Plus } from '@lucide/vue'
import { Button } from './ui/button'

defineProps<{ label: string }>()
</script>
<template>
    <Button type="button" variant="outline" class="min-h-36 flex-col gap-3 rounded-xl border-2 border-dotted">
        <Plus aria-hidden="true" class="size-6" />
        <span>{{ label }}</span>
    </Button>
</template>
